<p class="label-value-item__label">{{label}}</p>
<ng-content></ng-content>
